module.exports = __webpack_public_path__ + "static/images/solution.333dd88f498db6d915a5120eafa62f46.png";